<div class="vtr-ui-aps-slider"
	id="{{apsSliderId + '_range_slider'}}"
	attr.aria-label="{{apsSliderId + '_range_slider'}}"
	[attr.data-slider-value]="value"
	[ngClass]="{'disable-slider-pointer': enableSlider, 'on-hover-slider-icon':onHoverSliderIcon}">
	<ng5-slider [(value)]="value"
		[options]="options"
		(valueChange)="onValueChange($any($event))"
		(userChange)="onChange($event)"
		[manualRefresh]="manualRefresh"
		(userChangeEnd)="dragEnd()">
	</ng5-slider>
	<div class="row label">
		<div *ngFor="let legend of legends">{{ legend }}</div>
	</div>
</div>
